import type { ExpenseDueStatusFilter, ExpensePaymentStatusFilter, ExpenseSortBy } from '../domain/expenseTypes';
import { expenseErpCopy } from '../domain/expenseErpCopy';

export const EXPENSES_LIST_PAGE_SIZE_STORAGE_KEY = 'expenses_list_page_size';
export const EXPENSES_PAYMENTS_PAGE_SIZE_STORAGE_KEY = 'expenses_payments_page_size';

export type ExpensePeriodPreset = '7d' | '30d' | '90d' | 'all' | 'custom';

export const EXPENSE_PERIOD_PRESETS: Array<{ id: ExpensePeriodPreset; label: string; days?: number }> = [
  { id: '7d', label: '7 días', days: 7 },
  { id: '30d', label: '30 días', days: 30 },
  { id: '90d', label: '90 días', days: 90 },
  { id: 'all', label: 'Todos' },
  { id: 'custom', label: 'Personalizado' },
];

export const EXPENSE_PAYMENT_FILTER_OPTIONS: Array<{ value: ExpensePaymentStatusFilter; label: string }> = [
  { value: 'all', label: expenseErpCopy.paymentStatusFilter.all },
  { value: 'unpaid', label: expenseErpCopy.paymentStatusFilter.unpaid },
  { value: 'partial', label: expenseErpCopy.paymentStatusFilter.partial },
  { value: 'paid', label: expenseErpCopy.paymentStatusFilter.paid },
  { value: 'voided', label: expenseErpCopy.paymentStatusFilter.voided },
];

export const EXPENSE_DUE_FILTER_OPTIONS: Array<{ value: ExpenseDueStatusFilter; label: string }> = [
  { value: 'all', label: expenseErpCopy.dueStatusFilter.all },
  { value: 'overdue', label: expenseErpCopy.dueStatusFilter.overdue },
  { value: 'due_soon', label: expenseErpCopy.dueStatusFilter.due_soon },
  { value: 'no_due_date', label: expenseErpCopy.dueStatusFilter.no_due_date },
];

export const EXPENSE_SORT_OPTIONS: Array<{ value: ExpenseSortBy; label: string }> = [
  { value: 'expense_date_desc', label: 'Fecha (reciente)' },
  { value: 'amount_desc', label: 'Monto (mayor)' },
  { value: 'amount_asc', label: 'Monto (menor)' },
  { value: 'created_desc', label: 'Carga reciente' },
  { value: 'due_date_asc', label: 'Vencimiento (próximo)' },
  { value: 'due_date_desc', label: 'Vencimiento (lejano)' },
];
